import { useTranslation } from 'react-i18next'
import { CircleAlert } from 'lucide-react'
import { EmptyState } from '@vnetwork/datacentral-ui/data'
import { Button } from '@vnetwork/datacentral-ui/primitives'
import {
    getErrorMessage,
    translateKeyWithDetail,
} from '@/hooks/useMutationWithHandler'

interface TableErrorStateProps {
    error: unknown
    onRetry?: () => void
}

/** `ConfigTable` empty state shown when the list request failed. */
function TableErrorState({ error, onRetry }: TableErrorStateProps) {
    const { t } = useTranslation()
    const { t: tAxiosError } = useTranslation('axios-error')
    const message = getErrorMessage(error)
    const description =
        tAxiosError(message, { defaultValue: '' }) ||
        translateKeyWithDetail(message, tAxiosError) ||
        t(message)

    return (
        <EmptyState
            size="sm"
            icon={<CircleAlert size={24} />}
            title={t('table-load-failed')}
            description={description}
            actions={
                onRetry ? (
                    <Button size="sm" variant="secondary" onClick={onRetry}>
                        {t('reload')}
                    </Button>
                ) : undefined
            }
        />
    )
}

export default TableErrorState
